import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoPro2docsPutRes } from "./abst/DtoPro2docsPutRes";

export class DtoPro2docsPutResImple extends DtoPro2docsPutRes {}
